import ApiService from '@/services/api.service'

const NewCropService = { 

    getSetup() {
        const requestData = {
            method: 'get',
            url: "/NewCropAccounts/",       
            params: {}
          }
          return ApiService.customRequest(requestData);
    },
    
    sendRequest(code){
        const requestData = {
          method: 'post',
          url: '/NewCropGateway/RX',
          data: {
            patientCode: code
          }
        }
        return ApiService.customRequest(requestData);
    },

    medicationImport(code){
      const requestData = {
        method: 'post',
        url: '/EHRPatientRx',
        data: {
          patientCode: code
        }
      }
      return ApiService.customRequest(requestData);
    },

    checkUseNewCrop(){
      return ApiService.get('/NewCropGateway/checkUseNewCrop');
    }

  }
  
  export default NewCropService;